/**
 * LanguageSection - Language selection component
 *
 * Pure presentational component for switching app language.
 * Uses useLocale hook for persistence (AsyncStorage + i18n).
 */
import { View } from "react-native";
import { useTranslation, useLocale } from "@dramadetector/shared";
import { TierBody } from "@dramadetector/ui";
import { GlassCard } from "../../../components/glass";
import { SettingsItem } from "../../../components/SettingsItem";

export function LanguageSection() {
  const { t } = useTranslation('settings');
  const { locale, changeLocale } = useLocale();

  const handleLanguageChange = async (newLocale: string) => {
    await changeLocale(newLocale);
  };

  return (
    <View className="mt-4" testID="language-section">
      <TierBody size="xs" weight="semibold" className="text-gray-500 uppercase px-4 mb-2">
        {t('sections.language')}
      </TierBody>
      <GlassCard>
        <SettingsItem
          icon="🌐"
          label={t('language.title')}
          description={t('language.description')}
          testID="language-section-header"
        />
        <View className="border-t border-gray-200" />
        <SettingsItem
          icon="🇺🇸"
          label={t('language.english')}
          onPress={() => handleLanguageChange('en')}
          selected={locale === 'en'}
          testID="language-option-en"
        />
        <View className="border-t border-gray-200" />
        <SettingsItem
          icon="🇪🇸"
          label={t('language.spanish')}
          onPress={() => handleLanguageChange('es')}
          selected={locale === 'es'}
          testID="language-option-es"
        />
      </GlassCard>
    </View>
  );
}
